import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { Plan, CheckoutResponse, BillingPortalResponse } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const plansApi = {
	index: (): Promise<AxiosResult<Plan[]>> => {
		return axiosRequest({ url: `${API_BASE_URL}/plans`, method: "GET" });
	},

	createCheckout: (workspaceId: string, planId?: string): Promise<AxiosResult<CheckoutResponse>> => {
		return axiosRequest({
			url: `${API_BASE_URL}/${workspaceId}/billing/checkout`,
			method: "POST",
			data: planId ? { plan_id: planId } : undefined,
		});
	},

	getBillingPortal: (workspaceId: string): Promise<AxiosResult<BillingPortalResponse>> => {
		return axiosRequest({
			url: `${API_BASE_URL}/${workspaceId}/billing/portal`,
			method: "GET",
		});
	},
};
